<template>
    <div>
    </div>
</template>


<script>

export default {
  created() {
    this.$vs.loading();
    const isLoggedIn = localStorage.getItem(
        `${process.env.VUE_APP_ACCESS_TOKEN_NAME}LoggedIn`
    );
    if(!isLoggedIn){
        const pageSlug = this.$route.params.pageSlug;
        this.$router.push({
            path: '/login',
            query: {
                sharedShopPage: pageSlug,
            },
        });
    } else {
        // auth.js resolves the role-prefixed target before this ever mounts.
        // Reaching here means the route is not wired into publicPages, so fail
        // somewhere visible rather than on a blank page.
        this.$router.replace('/');
    }
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
</style>
